import * as React from 'react';

export function SvgGithub(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.005 1.88C6.41094 1.88 1.88 6.52555 1.88 12.2611C1.88 16.8547 4.77829 20.7347 8.80297 22.1102C9.30922 22.201 9.49907 21.8896 9.49907 21.6171C9.49907 21.3705 9.48641 20.553 9.48641 19.6836C6.9425 20.1637 6.28438 19.0478 6.08188 18.4638C5.96797 18.1654 5.47438 17.244 5.04407 16.9975C4.68969 16.8028 4.18344 16.3227 5.03141 16.3097C5.82876 16.2968 6.39829 17.0624 6.58813 17.3738C7.49938 18.9439 8.95485 18.5027 9.53704 18.2302C9.62563 17.5555 9.89141 17.1013 10.1825 16.8418C7.92969 16.5822 5.57563 15.6869 5.57563 11.7161C5.57563 10.5872 5.96797 9.65285 6.61344 8.92618C6.51219 8.66665 6.15782 7.60259 6.71469 6.17518C6.71469 6.17518 7.56266 5.90268 9.49907 7.23925C10.3091 7.00567 11.1697 6.88889 12.0303 6.88889C12.8909 6.88889 13.7516 7.00567 14.5616 7.23925C16.498 5.8897 17.3459 6.17518 17.3459 6.17518C17.9028 7.60259 17.5484 8.66665 17.4472 8.92618C18.0927 9.65285 18.485 10.5742 18.485 11.7161C18.485 15.6998 16.1183 16.5822 13.8655 16.8418C14.2325 17.1662 14.5489 17.789 14.5489 18.7623C14.5489 20.1507 14.5363 21.2667 14.5363 21.6171C14.5363 21.8896 14.7261 22.214 15.2323 22.1102C19.2317 20.7347 22.13 16.8418 22.13 12.2611C22.13 6.52555 17.5991 1.88 12.005 1.88Z"
        fill="black"
      />
    </svg>
  );
}
